import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { List, X } from '@phosphor-icons/react';

const DASHBOARD_LOGIN = 'https://app.inked.fit/login';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isMobileMenuOpen]);

  const handleLinkClick = () => setIsMobileMenuOpen(false);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm' : 'bg-white'
      }`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">

            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img src="/logo.png" alt="Inked" className="h-7 w-auto" />
            </Link>

            {/* Desktop centre links */}
            <div className="hidden md:flex items-center gap-8">
              {['Features', 'How it works', 'FAQ'].map((label) => (
                <a
                  key={label}
                  href={`/#${label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {label}
                </a>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center">
              <a
                href={DASHBOARD_LOGIN}
                className="text-sm font-semibold bg-[#2228B6] hover:bg-[#1a1f9e] text-white px-5 py-2 rounded-lg transition-colors"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Admin Log In
              </a>
            </div>

            {/* Mobile toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:text-gray-900"
              aria-label="Toggle menu"
            >
              <List size={24} weight="bold" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile drawer */}
      {isMobileMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <div className="fixed top-0 right-0 bottom-0 w-72 bg-white border-l border-gray-200 z-50 md:hidden">
            <div className="flex justify-end p-5">
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="w-9 h-9 flex items-center justify-center text-gray-500 hover:text-gray-900"
              >
                <X size={22} weight="bold" />
              </button>
            </div>
            <nav className="px-6 space-y-1">
              {['Features', 'How it works', 'FAQ'].map((label) => (
                <a
                  key={label}
                  href={`/#${label.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={handleLinkClick}
                  className="block text-base font-medium text-gray-600 hover:text-gray-900 py-3 border-b border-gray-100 transition-colors"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {label}
                </a>
              ))}
              <div className="pt-6">
                <a
                  href={DASHBOARD_LOGIN}
                  onClick={handleLinkClick}
                  className="flex items-center justify-center w-full bg-[#2228B6] text-white px-5 py-3 rounded-xl font-semibold text-sm"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Admin Log In
                </a>
              </div>
              <div className="border-t border-gray-100 pt-4 mt-2">
                <Link to="/privacy" onClick={handleLinkClick} className="block text-sm text-gray-400 hover:text-gray-600 py-1.5">Privacy Policy</Link>
                <Link to="/terms" onClick={handleLinkClick} className="block text-sm text-gray-400 hover:text-gray-600 py-1.5">Terms of Service</Link>
              </div>
            </nav>
          </div>
        </>
      )}
    </>
  );
}
